import { Task } from '@shared/models/task.model';
import { TaskType } from '@shared/enums/task-type.enum';
import { TaskService } from '@shared/modules/tasks/services/task-service';
import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SubtasksService extends TaskService {
  parentId: number;
  parentTask: Task;
  type: TaskType;
  disabled: boolean = false;

  private _creationSubtasksList = new BehaviorSubject<Task[]>([]);
  readonly creationSubtasksList$ = this._creationSubtasksList.asObservable();

  private _taskList = new BehaviorSubject<Task[]>([]);
  readonly taskList$ = this._taskList.asObservable();

  get taskListSnapshot(): Task[] {
    return this._taskList.getValue();
  }

  taskAdd: EventEmitter<Task> = new EventEmitter();

  constructor() {
    super();
  }

  addTempSubtask(task: Task): void {
    const current = this._creationSubtasksList.value;
    this._creationSubtasksList.next([...current, task]);
  }

  clearCreationSubtasksList(): void {
    this._creationSubtasksList.next([]);
  }

  setTaskList(tasks: Task[]): void {
    this._taskList.next(tasks);
  }
}
